<template>
  <div>
    <o-field-group
      v-for="tax in taxOptions"
      :key="tax.value.idTax"
      v-slot="{ status }"
      :label="tax.value.name"
      :name="tax.value.name"
      class="mb-4 block"
    >
      <toggle-field v-model="currentValue" :status="status" :value="Number(tax.value.idTax)" />
    </o-field-group>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'

import {
  OFieldGroup,
} from '@/components/elements'

import { useTaxStore } from '~/stores/useTaxStore'

import {
  ToggleField,
} from '@/components/fields'

interface Props {
  modelValue?: any
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const taxStore = useTaxStore()

const currentValue = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

const taxes = computed(() => taxStore.all)

const taxOptions = computed(() => {
  return taxes.value.map((tax: any) => ({
    value: tax,
    text: tax.name,
  }))
})

const isMulti = computed(() => {
  return Array.isArray(currentValue.value)
})

onMounted(() => {
  taxStore.sync()
})
</script>
